export default __webpack_public_path__ + "locales/fr/HotkeysPanel.json?hash=9018d7dd6755025fcbc9cec21f3d4140";